module.exports = __webpack_public_path__ + "img/2wavLogo.ab0af90.png";